import { render } from "./dashboardWaiters.vue?vue&type=template&id=62c9ffcd&scoped=true"
import script from "./dashboardWaiters.vue?vue&type=script&lang=js"
export * from "./dashboardWaiters.vue?vue&type=script&lang=js"

import "./dashboardWaiters.vue?vue&type=style&index=0&id=62c9ffcd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c9ffcd"]])

export default __exports__